import { inject, Injectable } from '@angular/core';
import moment from 'moment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { Procedencia } from '../enums/Procedencia';
import { DeviceDetectorService } from 'ngx-device-detector';
import { PdfPayload } from '../models';

@Injectable({
  providedIn: 'root',
})
export class WebServicesService {
  token: any = environment.token;
  authToken: any = environment.authToken;
  tokenclp: any = 'CLP_4PP_P41M3NT';
  complemt: any = 'pasajes';
  procedencia: string = '';
  moviredCompl: any = 'movired';
  col: any = 4;
  newComplemt: any;
  newDomainUrl: any;
  newDomainUrlName: any;
  newDomainName: any;
  newDomainLogo: any;

  domain = [];

  urlSitio: any = environment.urlSitio;
  urlBase: any = `${this.urlSitio}/api/chilepasajes/web/4.0`;

  ws_soap: any;
  isMobile: any = false;
  isTablet: any = false;
  isDesktopDevice: any = false;
  isUnknown: any = false;

  urlApiManagement: string = environment.urlApiManagement;
  urlApiGatwayCache: string = environment.urlApiGatwayCache;

  urlApiChilepasajes: string = environment.urlApiChilepasajes;
  public http = inject(HttpClient);
  public cookieService = inject(CookieService);
  private deviceService = inject(DeviceDetectorService);
  getpdf: boolean;
  constructor() {
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktopDevice = this.deviceService.isDesktop();
  }
  /**
   * Descargar PDF. Obtiene el PDF de la reserva o recarga
   * @param item - Objeto con idpago y opcionalmente idpago_det
   * @returns - PDF de la reserva o recarga
   */
  async getPDF(item: PdfPayload) {
    let endpoint = '';
    const headers = new HttpHeaders({ 
      'Cache-Control': 'max-age=0', 
      'Authorization': `Bearer ${this.authToken}`,
      'Accept': 'application/pdf'
    });

    if (item.tipo === 'ticket') {
      endpoint = `${this.urlApiGatwayCache}/buses/download_ticket/?order=${item.idpago}&order_det=${item.idpago_det}`
    } else {
      endpoint = `${this.urlApiGatwayCache}/recargas/download_recarga/?order=${item.idpago}`
    }

    return this.http.get(endpoint, { responseType: 'blob', headers });
  }
  
  private buildSoapRequest(action: string, params: any) {
    let body = '';
    for (const [key, value] of Object.entries(params)) {
      body += `<${key}>${value}</${key}>`;
    }
    return `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
              <soapenv:Body>
                <${action}>
                ${body}
                </${action}>
              </soapenv:Body>
            </soapenv:Envelope>`;
  }
  sanitize(str) {
    return str.replace(/[^a-zA-Z0-9-/ ]/g, '');
  }

  getSeats(array) {
    let arrayReserve = [];
    for (let variable of array) {
      arrayReserve.push(variable['obj'].idreserve);
    }

    return arrayReserve.join(',');
  }

  selectType(type: string, object: any, session = undefined) {
    let sr: any, endpoint: any, soap_act: any;
    let formData: any;
    let accessToken: string | null;

    // Flags
    let callPost = true;
    let callRestPost = false;
    let bodyType = 'urlEncoded';
    let keys = true;
    let CacheEnApi = false;

    /*****************************************
    /           FLUJO COMPRA BUSES
    *****************************************/
    // Obtener Empresas
    // No ocupado? compra_empresas era empresas, pero colinda con empresas del mapa
    // de sitio
    if (type === 'compra_empresas') {
      CacheEnApi = true;
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/buses/get_empresas`;
    }

    // Obtenre Rutas Empresas
    if (type === 'rutas') {
      CacheEnApi = true;
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/get_rutas`;
    }

    // Horarios
    if (type === 'travels') {
      CacheEnApi = true;
      callPost = false;
      let complement =
        this.newComplemt &&
        this.complemt.toLowerCase() !== this.newComplemt.toLowerCase() &&
        this.newComplemt != this.moviredCompl
          ? this.newComplemt
          : this.complemt;
      endpoint = `${this.urlApiGatwayCache}/buses/schedules?city_or=${object[
        'origin'
      ]
        .toLowerCase()
        .replace('ñ', 'n')
        .replace(' ', '-')}&city_de=${object['destination']
        .toLowerCase()
        .replace('ñ', 'n')
        .replace(' ', '-')}&date_or=${moment(object['dateOrigin']).format(
        'DD-MM-YYYY'
      )}&goto=${object['goto'].toLowerCase()}&complemento=${complement}`;
    }

    // Mapa de Asientos
    if (type === 'seat_map') {
      callPost = false;
      endpoint = `${
        this.urlApiGatwayCache
      }/buses/seat/?token=${encodeURIComponent(object['token'])}&session=${
        object['session']
      }`;
    }

    // Set elements for set_reserve and reservar_transfer
    if (type === 'set_reserve' || type === 'reservar_transfer') {
      var device: any = 'M';
      if (this.isMobile) {
        device = 'M';
      }
      if (this.isTablet) {
        device = 'T';
      }
      if (this.isDesktopDevice) {
        device = 'P';
      }
      var adwords = 0;
      if (this.cookieService.get('adwords')) {
        adwords = Number(this.cookieService.get('adwords'));
      }
      var utm_source: any = '';
      if (this.cookieService.get('utm_source')) {
        utm_source = this.cookieService.get('utm_source');
      }
      var utm_campaign: any = '';
      if (this.cookieService.get('utm_campaign')) {
        utm_campaign = this.cookieService.get('utm_campaign');
      }
      var utm_medium: any = '';
      if (this.cookieService.get('utm_medium')) {
        utm_medium = this.cookieService.get('utm_medium');
      }

      var ads_route: any = '';
      if (this.cookieService.get('ads_route')) {
        ads_route = this.cookieService.get('ads_route');
      }
    }

    // Reservas
    if (type === 'set_reserve') {
      callRestPost = true;

      bodyType = 'json';
      // Generate Raw Payload
      const complemento =
        this.newComplemt &&
        this.complemt.toLowerCase() !== this.newComplemt.toLowerCase() &&
        this.newComplemt != this.moviredCompl
          ? this.newComplemt
          : this.complemt;

      formData = {
        session: session,
        reservas: object,
        complemento: complemento,
        device: device,
        adwords: adwords,
        utm_source: utm_source,
        utm_campaign: utm_campaign,
        utm_medium: utm_medium,
        ads_route: ads_route,
      };
      // endpoint = `${
      //   this.urlApiGatwayCache
      // }/buses/reserve/?reservas=${encodeURIComponent(
      //   this.getSeats(object)
      // )}&session=${session}&complemento=${complemento}&device=${device}&adwords=${adwords}&utm_source=${utm_source}&utm_campaign=${utm_campaign}&utm_medium=${utm_medium}&ads_route=${encodeURIComponent(
      //   ads_route
      // )}`;
      endpoint = `${this.urlApiGatwayCache}/buses/reserve/`;
    }

    // Paraderos
    if (type === 'stops') {
      CacheEnApi = true;
      callPost = false;
      endpoint = `${
        this.urlApiGatwayCache
      }/buses/stops/?token=${encodeURIComponent(object['token'])}`;
    }

    // Datos Pasajeros / Comprador
    if (type === 'update_reserve') {
      callRestPost = true;
      bodyType = 'json';

      // separate accessToken from object
      if (object['accessToken']) {
        accessToken = object['accessToken'];
      }
      delete object['accessToken'];

      formData = object;
      endpoint = `${this.urlApiGatwayCache}/buses/update_reserve/`;
    }

    // Confirmación de Orden
    if (type === 'confirmate_order') {
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/buses/confirmate_order/?order=${object['idpago']}`;
    }

    // Exito
    if (type == 'page_success') {
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/buses/exito/?idpago=${object['idpago']}`;
    }

    // Descuento cliente rut Cupon
    if (type === 'descuento_cliente_rut') {
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/buses/coupon_rut/?rut=${object['rut']}&idpago=${object['idpago']}`;
    }

    /*****************************************
    /           FLUJO RECARGAS
    *****************************************/
    // Contratos
    if (type === 'get_contracts') {
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/recargas/contratos`;
    }

    // Metodos de Pago
    if (type === 'get_payment_methods') {
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/recargas/metodos_pagos`;
    }

    // Generar Recarga Cuenta
    if (type === 'recharge_account') {
      callPost = false;
      const endpointBase = `${this.urlApiGatwayCache}/recargas/generar_recarga?`;
      const queryParams: string[] = [];

      // delete keys based on [tipo]
      if (object['tipo'] === 'rut') {
        delete object['folio'];
      } else {
        delete object['rut'];
      }

      for (const [key, value] of Object.entries(object)) {
        queryParams.push(`${key}=${encodeURIComponent(value as string)}`);
      }

      endpoint = endpointBase + queryParams.join('&');
    }

    // Recarga Exitosa
    if (type === 'recharge_success') {
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/recargas/recarga_exitosa?order=${object['idOrder']}`;
    }

    // consulta saldo
    if (type === 'consulta_saldo') {
      callPost = false;
      const { tipo, infoConsulta } = object;

      let queryParam: string = '';
      if (tipo === 'rut') {
        queryParam = `rut_input=${infoConsulta}`;
      } else {
        queryParam = `folio=${infoConsulta}`;
      }

      endpoint = `${this.urlApiGatwayCache}/recargas/consulta_saldo?tipo=${tipo}&${queryParam}`;
    }

    /*****************************************
    /           FLUJO ANULACIONES
    *****************************************/
    // Obtener boletos
    if (type === 'get_tickets_idpago_ws') {
      callRestPost = true;
      formData = {
        method: 'get_tickets_idpago_ws',
        idpago: object['idpago'],
        email: object['email'],
      };

      endpoint = `${this.urlApiGatwayCache}/buses/cancel_ticket`;
    }

    // Crear Código
    if (type === 'create_code') {
      callRestPost = true;
      formData = {
        accion: object['accion'],
        idpago: object['idpago'],
        idpago_det: object['idpago_det'],
        correo: object['correo'],
        codigo: object['codigo'],
      };
      endpoint = `${this.urlApiGatwayCache}/buses/create_code/`;
    }

    // Listar Paraderos (combinado con area_cliente)
    if (type === 'ticket_listar_paradero') {
      callRestPost = true;
      formData = {
        method: 'ticket_listar_paradero',
        idpago: object['idpago'],
        idpago_det: object['iddetalle'],
      };

      if (object['procedencia'] === Procedencia.GESTION_BOLETOS) {
        accessToken = object['accessToken'];
        endpoint = `${this.urlApiGatwayCache}/buses/cancel_ticket`;
      }
      if (object['procedencia'] === Procedencia.MI_CUENTA) {
        accessToken = object['accessToken'];
        endpoint = `${this.urlApiGatwayCache}/area_cliente/cancel_ticket`;
      }
    }

    // Anulación Ticket (combinado con area_cliente)
    if (type === 'cancel_ticket_webpay') {
      callRestPost = true;
      formData = {
        method: '',
        idpago: object['idpago'],
        idpago_det: object['iddetalle'],
        can_name: object['fullname'],
        can_rut: object['rut'],
        can_banco: object['bank'],
        can_tipcta: object['accountType'],
        can_cuenta: object['accountNumber'],
        via: object['via'],
        email: object['email'],
        codigo: object['codigo'],
      };
      if (object['procedencia'] === Procedencia.GESTION_BOLETOS) {
        formData.method = 'cancel_ticket_verify';
        endpoint = `${this.urlApiGatwayCache}/buses/cancel_ticket`;
      }
      if (object['procedencia'] === Procedencia.MI_CUENTA) {
        formData.method = 'cancel_ticket_user';
        accessToken = object['accessToken'];
        endpoint = `${this.urlApiGatwayCache}/area_cliente/cancel_ticket`;
      }
    }

    // Anulación Transfer (combinado con area_cliente)
    if (type === 'cancel_transfer_user') {
      callRestPost = true;
      formData = {
        method: '',
        id_prod: object['idprod'],
        idpago: object['idpago'],
        idpago_det: object['iddetalle'],
        can_name: object['nombre'],
        can_rut: object['rut'],
        can_banco: object['banco'],
        can_tipcta: object['tipo_cuenta'],
        can_cuenta: object['cuenta'],
        via: object['via'],
        email: object['email'],
        codigo: object['codigo'],
      };

      if (object['procedencia'] === Procedencia.GESTION_BOLETOS) {
        formData.method = 'cancel_transfer_verify';
        endpoint = `${this.urlApiGatwayCache}/buses/cancel_ticket`;
      }
      if (object['procedencia'] === Procedencia.MI_CUENTA) {
        formData.method = 'cancel_transfer_user';
        accessToken = object['accessToken'];
        endpoint = `${this.urlApiGatwayCache}/area_cliente/cancel_ticket`;
      }
    }

    // Cambio Ticket (combinado con area_cliente)
    if (type === 'cambio_ticket') {
      callRestPost = true;
      formData = {
        method: '',
        idpago: object['idpago'],
        idpago_det: object['iddetalle'],
        email: object['email'],
        codigo: object['codigo'],
      };

      if (object['procedencia'] === Procedencia.GESTION_BOLETOS) {
        formData.method = 'cambio_ticket_verify';
        endpoint = `${this.urlApiGatwayCache}/buses/cancel_ticket`;
      }
      if (object['procedencia'] === Procedencia.MI_CUENTA) {
        formData.method = 'cambio_ticket_user';
        accessToken = object['accessToken'];
        endpoint = `${this.urlApiGatwayCache}/area_cliente/cancel_ticket`;
      }
    }

    // Cambio Parada/Bajada (combinado con area_cliente)
    if (type === 'ticket_cambio_paradero') {
      callRestPost = true;
      formData = {
        method: '',
        idpago: object['idpago'],
        idpago_det: object['iddetalle'],
        subida: object['subida'],
        bajada: object['bajada'],
        email: object['email'],
        codigo: object['codigo'],
      };

      if (object['procedencia'] === Procedencia.GESTION_BOLETOS) {
        formData.method = 'ticket_cambio_paradero_verify';
        endpoint = `${this.urlApiGatwayCache}/buses/cancel_ticket`;
      }
      if (object['procedencia'] === Procedencia.MI_CUENTA) {
        formData.method = 'ticket_cambio_paradero_user';
        accessToken = object['accessToken'];
        endpoint = `${this.urlApiGatwayCache}/area_cliente/cancel_ticket`;
      }
    }

    if (type === 'resend_ticket_mail') {
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/buses/send_email/?order=${object['order']}&api=${this.token}`;
    }

    /*****************************************
    /           AREA CLIENTES
    *****************************************/
    // TRAVELERS

    // Listar Viajeros
    if (type === 'travelers_get') {
      callRestPost = true;
      formData = {
        method: 'travelers_get_all',
      };
      accessToken = object['accesstoken'];
      endpoint = `${this.urlApiGatwayCache}/area_cliente/travelers_crud`;
    }

    // Insertar Viajero
    if (type === 'travelers_create') {
      callRestPost = true;
      formData = {
        method: 'travelers_create',
        rut: object['rut'],
        firstname: object['firstname'],
        lastname: object['lastname'],
        email: object['email'],
        city: object['city'],
        country: object['country'],
        phone: object['phone'],
        typerutpassport: object['typerutpassport'],
      };

      accessToken = object['accesstoken'];
      endpoint = `${this.urlApiGatwayCache}/area_cliente/travelers_crud`;
    }

    // Actualizar Viajero
    if (type === 'travelers_put') {
      callRestPost = true;
      formData = {
        method: 'travelers_update',
        rut: object['rut'],
        firstname: object['firstname'],
        lastname: object['lastname'],
        email: object['email'],
        city: object['city'],
        country: object['country'],
        phone: object['phone'],
        typerutpassport: object['typerutpassport'],
        passengerid: object['passengerid'],
      };
      accessToken = object['accesstoken'];
      endpoint = `${this.urlApiGatwayCache}/area_cliente/travelers_crud`;
    }

    // Eliminar Viajero
    if (type === 'travelers_delete') {
      callRestPost = true;
      formData = {
        method: 'travelers_delete',
        passengerid: object['passengerid'],
      };
      accessToken = object['accesstoken'];
      endpoint = `${this.urlApiGatwayCache}/area_cliente/travelers_crud`;
    }

    // CUENTA

    // Registrar
    if (type === 'register') {
      callRestPost = true;
      formData = {
        email: object['email'],
        firstname: object['firstname'],
        lastname: object['lastname'],
        password: object['password'],
        fbid: '',
        fbpic: '',
      };
      endpoint = `${this.urlApiGatwayCache}/area_cliente/register`;
    }

    // Login
    if (type === 'login') {
      callRestPost = true;
      formData = {
        email: object['email'],
        password: object['password'],
      };
      endpoint = `${this.urlApiGatwayCache}/area_cliente/user_login`;
    }

    // Google Login
    if (type === 'google_login') {
      callRestPost = true;
      const {google_token} = object;
      endpoint = `${this.urlApiGatwayCache}/area_cliente/user_login_google`;

      // Se necesita retornar early, al refactorizar se debe cambiar
      return this.restCallPost(endpoint, google_token)
    }

    // Recuperar Correo
    if (type === 'recover_email') {
      callRestPost = true;
      formData = {
        email_send: object['email'],
      };
      endpoint = `${this.urlApiGatwayCache}/area_cliente/recover_email`;
    }

    // Recuperar Contraseña
    if (type === 'recover_password') {
      callRestPost = true;
      const { recode, password, confirmPassword } = object;
      formData = {
        recode: recode,
        new_password: password,
        new_password_retype: confirmPassword,
      };

      endpoint = `${this.urlApiGatwayCache}/area_cliente/recover_password`;
    }

    // Datos Usuario
    if (type === 'user_data') {
      callRestPost = true;

      accessToken = object['accessToken'];
      endpoint = `${this.urlApiGatwayCache}/area_cliente/user_data`;
    }

    // Puntos
    if (type === 'points_user') {
      callRestPost = true;
      accessToken = object['accessToken'];
      endpoint = `${this.urlApiGatwayCache}/area_cliente/puntos`;
    }

    // Actualizar Datos Usuario
    if (type === 'user_update') {
      callRestPost = true;
      formData = {
        email: object['email'],
        rut: object['rut'],
        fname: object['firstname'],
        lname: object['lastname'],
        phone: object['phone'],
        country: object['country'],
      };
      accessToken = object['accessToken'];
      endpoint = `${this.urlApiGatwayCache}/area_cliente/update`;
    }

    // Listar Boletos
    if (type === 'tickets_by_id') {
      callRestPost = true;
      formData = {
        method: 'get_tickets_ws',
      };
      accessToken = object['accessToken'];
      endpoint = `${this.urlApiGatwayCache}/area_cliente/get_tickets`;
    }

    // Obtener Boletos Transfer
    if (type === 'tickets_transfer_by_id') {
      callRestPost = true;
      formData = {
        method: 'get_tickets_transfer_ws',
      };
      accessToken = object['accessToken'];
      endpoint = `${this.urlApiGatwayCache}/area_cliente/get_tickets`;
    }

    // Obtener Boletos Anulados
    if (type === 'cancelled_by_id') {
      callRestPost = true;
      formData = {
        method: 'get_cancelled_by_id_ws',
      };
      accessToken = object['accessToken'];
      endpoint = `${this.urlApiGatwayCache}/area_cliente/get_cancelled`;
    }

    // Obtener Cupones
    if (type === 'get_coupons') {
      callRestPost = true;
      accessToken = object['accessToken'];
      endpoint = `${this.urlApiGatwayCache}/area_cliente/get_coupons`;
    }

    // Eliminar Cuenta
    if (type === 'delete_account') {
      callRestPost = true;
      formData = {
        email: object['email'],
        lang: object['lang'],
      };
      endpoint = `${this.urlApiGatwayCache}/area_cliente/user_delete_request`;
    }

    // Confirmar Eliminación de Cuenta
    if (type === 'confirm_delete_account') {
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/area_cliente/user_delete?code=${object['code']}`;
    }
    /*****************************************
    /               MAPA DEL SITIO
    *****************************************/

    // Destinos
    if (type === 'destinos') {
      CacheEnApi = true;
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/get_destinos`;
    }

    // Empresas
    if (type === 'empresas') {
      CacheEnApi = true;
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/get_empresas`;
    }

    // Rutas
    if (type === 'rutas') {
      CacheEnApi = true;
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/get_rutas`;
    }

    // Terminales
    if (type === 'terminales') {
      CacheEnApi = true;
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/get_terminales`;
    }

    // Info Ciudad
    if (type === 'info_ciudad') {
      CacheEnApi = true;
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/info_ciudades/?url_ciudad=${object['ciudad']}`;
    }

    // Info Empresas
    if (type === 'info_empresa') {
      CacheEnApi = true;
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/info_empresas/?url_empresa=${object['empresa']}`;
    }

    // Info Terminales
    if (type == 'info_terminales') {
      CacheEnApi = true;
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/info_terminales/?url_terminal=${object['terminal']}`;
    }


    /*****************************************
    /           FIN MAPA DEL SITIO
    *****************************************/
    if (type === 'cities') {
      CacheEnApi = true;
      callPost = false;
      let complement: any;
      complement =
        this.newComplemt &&
        this.complemt.toLowerCase() !== this.newComplemt.toLowerCase() &&
        this.newComplemt != this.moviredCompl
          ? this.newComplemt
          : this.complemt;
      if (object['newComplemt']) {
        complement = object['newComplemt'];
      }
      endpoint = `${this.urlApiGatwayCache}/buses/getcity/?complemento=${complement}`;
    }

    if (type == 'status_payment') {
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/buses/status_payment/?idpago=${object['idpago']}`;
    }

    if (type === 'get_data_passenger_ws') {
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/buses/data_passenger/?id=${object['id']}&typerutpassport=${object['typeDocument']}`;
    }

    if (type === 'get_coupons_by_code') {
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/buses/coupons/?method=get_cupon_by_codigo_ws&codigo=${object['codigo']}&idpago=${object['idpago']}`;
    }

    if (type === 'change_points') {
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/buses/coupons/?userid=${object['userid']}&puntos=${object['points']}&monto_cupon=${object['amount']}&method=canjear_cupon_ws`;
    }

    if (type === 'cancel_reserve') {
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/buses/cancel_reserve/?session=${object['session']}`;
    }

    if (type == 'comuna_transfer') {
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/buses/comuna_transfer/?idpago=${object['idpago']}&comuna=${object['comuna']}&direccion=${object['direccion']}`;
    }



    //TODO: REVISAR CUANDO SE INCORPORE TRANSFER
    // if (type === "cancel_ticket_webpay_transfer") {
    //   if (object["procedencia"] === Procedencia.GESTION_BOLETOS) {
    //     sr = this.buildSoapRequest("cancel_transfer_verify", {
    //       api: this.token,
    //       idprod: object["idprod"],
    //       idpago: object["idpago"],
    //       iddetalle: object["iddetalle"],
    //       nombre: object["nombre"],
    //       rut: object["rut"],
    //       banco: object["banco"],
    //       tipo_cuenta: object["tipo_cuenta"],
    //       cuenta: object["cuenta"],
    //       via: object["via"],
    //       codigo: object["codigo"],
    //       email: object["email"]
    //     });
    //     endpoint = `${this.urlBase}/cancel_ticket.php`;
    //   }

    //   if (object["procedencia"] === Procedencia.MI_CUENTA) {

    //     sr = this.buildSoapRequest("cancel_transfer_user", {
    //       api: this.token,
    //       idprod: object["idprod"],
    //       idpago: object["idpago"],
    //       iddetalle: object["iddetalle"],
    //       nombre: object["nombre"],
    //       rut: object["rut"],
    //       banco: object["banco"],
    //       tipo_cuenta: object["tipo_cuenta"],
    //       cuenta: object["cuenta"],
    //       via: object["via"],
    //       iduser: object["iduser"]
    //     });
    //     endpoint = `${this.urlBase}/cancel_ticket.php`;
    //   }
    // }

    // if (type === 'download_ticket') {
    //   endpoint = `${this.urlApiGatwayCache}/buses/download_ticket/?order=${object.idpago}&order_det=${object.idpago_det}`;
    //   if (this.tool.isBrowser()) {
    //     this.getPDF(endpoint).subscribe(
    //       (response) => {
    //         let file = new Blob([response], { type: "application/pdf" });
    //         var fileURL = URL.createObjectURL(file);
    //         FileSaver.saveAs(fileURL, `Pasaje_${object.idpago_det}.pdf`);
    //         console.log(fileURL);
    //         return fileURL;
    //       },
    //       (err) => { }
    //     );
    //   }
    //   // return this.getPDF(endpoint);
    // }

    if (type === 'user_update_confirm') {
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/buses/cancel_ticket_fix_data/?enc_idsolcancel=${object['idsolcancel']}&can_name=${object['nombre']}&can_rut=${object['rut']}&can_banco=${object['banco']}&can_tipcta=${object['tipo_cuenta']}&can_cuenta=${object['cuenta']}&method=cancel_ticket_update`;
    }

    if (type === 'update_cancelation') {
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/buses/cancel_ticket_fix_data/?enc_idsolcancel=${object['id']}&method=get_info_anulacion`;
    }

    if (type === 'bank') {
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/buses/get_bancos`;
    }

    if (type === 'get_info_ciudades') {
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/buses/info_city/?origen=${object[
        'origin'
      ]
        .toLowerCase()
        .replace('ñ', 'n')}&destino=${object['destination']
        .toLowerCase()
        .replace('ñ', 'n')}`;
    }

    if (type === 'travels-seo') {
      callPost = false;
      let complement =
        object['cmpl'] &&
        this.complemt.toLowerCase() !== object['cmpl'].toLowerCase() &&
        object['cmpl'] != this.moviredCompl
          ? object['cmpl']
          : this.complemt;
      endpoint = `${
        this.urlApiGatwayCache
      }/buses/get_schedules/?or_text=${object['origin']
        .toLowerCase()
        .replace('ñ', 'n')}&de_text=${object['destination']
        .toLowerCase()
        .replace('ñ', 'n')}&or_fecha=${moment(object['dateOrigin']).format(
        'DD-MM-YYYY'
      )}&goto=${object['goto'].toLowerCase()}&complemento=${complement}`;
    }

    /**
     * obtener ciudades disponibles para horarios de buses
     */

    /**
     * comunas sugeridas para búsquedas
     */
    if (type === 'sugerencias_transfer') {
      /*sr = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
                <soapenv:Body>
                    <listado_terminales>
                        <api>${this.token}</api>
                    </listado_terminales>
                </soapenv:Body>
            </soapenv:Envelope>`;*/
      sr = this.buildSoapRequest('listado_terminales', { api: this.token });
      endpoint = `${this.urlBase}/listado_terminales_punto.php`;
    }
    /**
     * listar horarios de buses
     */

    /**
     * listar horarios de transfer
     */
    if (type === 'travels-transfer') {
      callPost = false;
      endpoint = `${this.urlBase}/01_schedules_transfer_prev.php?api=${
        this.token
      }&city_or=${object['origin']
        .toLowerCase()
        .replace('ñ', 'n')}&city_de=${object['destination']
        .toLowerCase()
        .replace('ñ', 'n')}&date_or=${
        object['dateOrigin']
      }&goto=IDA&complemento=${object['complement']}&hora=${object['time']}`;
    }
    ////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////          MAPA DE ASIENTOS       /////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////
    /**
     * mapa de asientos de buses
     */

    /**
     * eliminar cache de horarios
     */
    if (type === 'delete-travels-key') {
      /* callPost = false;
       keys = false;
       endpoint = `${environment.urlCache}/api/HTTPDeleteCacheCLP?code=HbAehfkLugjtvAdV1ig1NGSF2BI4rn7Ac6844xZCmCuQbDoR5ki1aw==&proceso=1&origen=${object["origen"]
         .toLowerCase().replace(" ", "-")}&destino=${object["destino"]
         .toLowerCase().replace(" ", "-")}&fecha=${moment(object["fecha"]).format("DD-MM-YYYY")}&complemento=${object["complemento"].toLowerCase()}`;*/
    }

    /**
     * eliminar reservas de asientos
     */

    ////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////          RESERVAS PÁGINA        /////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////
    /**
     * variables generales para reservas
     */
    // if (type === "set_reserve" || type === "reservar_transfer") {
    //   var device: any = "M";
    //   if (this.isMobile) {
    //     device = "M";
    //   }
    //   if (this.isTablet) {
    //     device = "T";
    //   }
    //   if (this.isDesktopDevice) {
    //     device = "P";
    //   }
    //   var adwords: any = "";
    //   if (this.cookieService.get("adwords")) {
    //     adwords = "1";
    //   }
    //   var utm_source: any = "";
    //   if (this.cookieService.get("utm_source")) {
    //     utm_source = this.cookieService.get("utm_source");
    //   }
    // }
    /**
     * reserva de pasajes de buses
     */

    /**
     * reserva de pasajes de transfer
     */
    if (type === 'reservar_transfer') {
      /*
      sr = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
          <soapenv:Body>
              <set_reserve_transfer>
                  <api>${this.token}</api>
                  <reservas>${object["reservas"]}</reservas>
                  <dir_origen>${object["dir_origen"]}</dir_origen>
                  <dir_destino>${object["dir_destino"]}</dir_destino>
                  <hora>${object["hora"]}</hora>
                  <cant_pasajeros>${object["cant_pasajeros"]}</cant_pasajeros>
                  <session>${object["session"]}</session>
                  <complemento>${object["complemento"].toLowerCase()}</complemento>
                  <device>${device !== undefined ? device: ''}</device>
                  <adwords>${adwords !== undefined ? adwords: ''}</adwords>
                  <utm_source>${utm_source !== undefined ? utm_source: ''}</utm_source>
                  <hora_reg></hora_reg>
              </set_reserve_transfer>
          </soapenv:Body>
      </soapenv:Envelope>`;*/
      sr = this.buildSoapRequest('set_reserve_transfer', {
        api: this.token,
        reservas: object['reservas'],
        dir_origen: object['dir_origen'],
        dir_destino: object['dir_destino'],
        hora: object['hora'],
        cant_pasajeros: object['cant_pasajeros'],
        session: object['session'],
        complemento: object['complemento'].toLowerCase(),
        device: device !== undefined ? device : '',
        adwords: adwords !== undefined ? adwords : 0,
        utm_source: utm_source !== undefined ? utm_source : '',
        hora_reg: '',
      });
      endpoint = `${this.urlBase}/03_reserve_transfer.php`;
    }
    ////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////           PANTALLA PAGO         /////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////
    /**
     * actualizar compra de pasajes de bus
     */

    /**
     * actualizar compra de transfer
     */
    if (type === 'update_reserve_transfer') {
      /*sr = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
        <soapenv:Body>
          <update_reserve_transfer>
            <api>${this.token}</api>
            <carro>${object["carro"]}</carro>
            <pasajeros></pasajeros>
            <iduser>${object["sessionid"]}</iduser>
            <cupon>${object["cupon"]}</cupon>
          </update_reserve_transfer>
        </soapenv:Body>
      </soapenv:Envelope>`;*/
      sr = this.buildSoapRequest('update_reserve_transfer', {
        api: this.token,
        carro: object['carro'],
        pasajeros: '',
        iduser: object['sessionid'],
        cupon: object['cupon'],
      });
      endpoint = `${this.urlBase}/04_update_reserve_transfer.php`;
    }
    ////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////    VALIDACIONES PANTALLA PAGO   /////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////

    /**
     * TODO este webservice no está siendo utilizado
     * aplicar cupón a compra en pantalla de transfer
     */
    if (type === 'get_coupons_transfer') {
      /*sr = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
          <soapenv:Body>
            <get_cupon_by_session_ws>
              <api>${this.token}</api>
              <codigo>${object["codigo"]}</codigo>
              <session>${object["idsession"]}</session>
              <tipo_compra>TRANSFER</tipo_compra>
            </get_cupon_by_session_ws>
          </soapenv:Body>
        </soapenv:Envelope>`;*/
      sr = this.buildSoapRequest('get_cupon_by_session_ws', {
        api: this.token,
        codigo: object['codigo'],
        session: object['idsession'],
        tipo_compra: 'TRANSFER',
      });
      endpoint = `${this.urlBase}/coupons.php`;
    }
    /**
     * aplicar descuento con rut en pago buses (descuento clientes frecuentes)
     */

    /**
     * paradas de buses
     */

    /**
     * servicio para traer datos personas por rut
     * válido para buses y transfer
     */

    /**
     * verificar si la compra fue pagada si la compra ya fue pagada se debe sacar de la compra actual
     * sirve tanto para buses y transfer
     */

    ////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////    PRODUCTOS PANTALLA DE PAGO   /////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////
    /**
     * obtener comunas disponibles para horarios de buses
     * TODO revisar función en página
     */

    /**
     * obtener comunas disponibles para horarios de buses
     * TODO revisar función en página
     */
    if (type == 'obtener_comunas_transfer') {
      /* sr = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
        <soapenv:Body>
          <set_reserve>
            <api>${this.token}</api>
          </set_reserve>
        </soapenv:Body>
      </soapenv:Envelope>`;*/
      sr = this.buildSoapRequest('set_reserve', {
        api: this.token,
      });
      endpoint = `${this.urlBase}/get_comunas.php`;
    }
    ////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////          MEDIOS DE PAGO         /////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////
    /**
     * generar transacción fintoc
     */
    if (type === 'buy_fintoc') {
      /*sr = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
              <soapenv:Body>
                <add_payment>
                  <api>CH1L3P454J35_4PP_M0B1L3_PRUE845</api>
                  <idpago>${object["idpago"]}</idpago>
                </add_payment>
              </soapenv:Body>
            </soapenv:Envelope>`;*/
      sr = this.buildSoapRequest('add_payment', {
        api: 'CH1L3P454J35_4PP_M0B1L3_PRUE845',
        idpago: object['idpago'],
      });
      endpoint = `${this.urlBase}/fintoc.php`;
    }
    /**
     * generar transacción paypal
     * TODO no se está utilizando
     */
    // if (type === "payment_paypal") {
    //   sr = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
    //           <soapenv:Body>
    //             <add_payment>
    //               <api>${this.token}</api>
    //               <idpago>${object["idpago"]}</idpago>
    //               <idpaypal>${object["idpaypal"]}</idpaypal>
    //               <monto>${object["totalBuy"]}</monto>
    //               <estado>${object["status"]}</estado>
    //             </add_payment>
    //           </soapenv:Body>
    //         </soapenv:Envelope>`;
    //   endpoint = `${this.urlBase}/paypal.php`;
    // }
    ////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////          PÁGINA DE EXITO        /////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////
    /**
     * operación que confirma pasajes en la pantalla de éxito
     */

    /**
     * página de exito de boletos de bus
     */

    /**
     * página de exito de boletos de transfer
     */
    if (type == 'page_success_transfer') {
      /*sr = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
        <soapenv:Body>
          <pasajes_exito_transfer_ws>
            <api>${this.token}</api>
            <idpago>${object["idpago"]}</idpago>
          </pasajes_exito_transfer_ws>
        </soapenv:Body>
      </soapenv:Envelope>`;*/
      sr = this.buildSoapRequest('pasajes_exito_transfer_ws', {
        api: this.token,
        idpago: object['idpago'],
      });
      endpoint = `${this.urlBase}/06_exito_transfer.php`;
    }
    ////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////          ANULACIONES            /////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////

    /**
     * listar bancos para anulaciones
     */

    /**
     * obtener pasajes de bus a anular
     */

    /**
     * TODO este webservice no está siendo utilizado
     * listar transfers a anular
     */
    // if (type == "listado_transfers_anular") {
    //   sr = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
    //     <soapenv:Body>
    //       <get_tickets_idpago_ws>
    //         <api>${this.token}</api>
    //         <email>${object["email"]}</email>
    //         <idpago>${object["idpago"]}</idpago>
    //       </get_tickets_idpago_ws>
    //     </soapenv:Body>
    //   </soapenv:Envelope>`;
    //   endpoint = `${this.urlBase}/cancel_ticket.php`;
    // }

    /**
     * TODO este webservice no está siendo utilizado
     * anular boleto de bus vía paypal
     */
    // if (type === "cancel_ticket_paypal") {
    //   sr = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
    //     <soapenv:Body>
    //       <cancel_ticket>
    //         <api>${this.token}</api>
    //         <idpago>${object["idpago"]}</idpago>
    //         <iddetalle>${object["iddetalle"]}</iddetalle>
    //         <nombre></nombre>
    //         <rut></rut>
    //         <banco></banco>
    //         <tipo_cuenta></tipo_cuenta>
    //         <cuenta></cuenta>
    //         <via>${object["via"]}</via>
    //       </cancel_ticket>
    //     </soapenv:Body>
    //   </soapenv:Envelope>`;
    //   endpoint = `${this.urlBase}/cancel_ticket.php`;
    // }

    /**
     * anular boleto de bus
     */

    // if (type === "cancel_ticket") {
    //   sr = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
    //     <soapenv:Body>
    //       <cancel_ticket>
    //         <api>${this.token}</api>
    //         <idpago>${object["idpago"]}</idpago>
    //         <iddetalle>${object["iddetalle"]}</iddetalle>
    //       </cancel_ticket>
    //     </soapenv:Body>
    //   </soapenv:Envelope>`;
    //   endpoint = `${this.urlBase}/cancel_ticket.php`;
    // }

    /**
     * TODO este webservice no está siendo utilizado
     */
    // if (type == "anular_transfer") {
    //   sr = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
    //     <soapenv:Body>
    //       <cancel_transfer>
    //         <api>${this.token}</api>
    //         <idprod>${object["idprod"]}</idprod>
    //         <idpago>${object["idpago"]}</idpago>
    //         <iddetalle>${object["iddetalle"]}</iddetalle>
    //         <nombre>${object["nombre"]}</nombre>
    //         <rut>${object["rut"]}</rut>
    //         <banco>${object["banco"]}</banco>
    //         <tipo_cuenta>${object["tipo_cuenta"]}</tipo_cuenta>
    //         <cuenta>${object["cuenta"]}</cuenta>
    //         <via>${object["via"]}</via>
    //       </cancel_transfer>
    //     </soapenv:Body>
    //   </soapenv:Envelope>`;
    //   endpoint = `${this.urlBase}/cancel_ticket.php`;
    // }

    //////////////////////////////////////////////////////////////////////////////////
    ////////////////////////   ACTUALIZACIÓN ANULACIONES     /////////////////////////
    //////////////////////////////////////////////////////////////////////////////////

    /**
     * obtener información de anulación a actualizar
     */
    // if (type === "recovery_password") {
    //   callPost = false;
    //   endpoint = `${this.urlBase}/recovery_password.php&idpago=${object["idpago"]}&correo=${object["correo"]}&accion=${object["accion"]}&idpago_det=${object["idpago_det"]}`;
    // }

    ////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////   ACTUALIZACIÓN ANULACIONES     /////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////

    /**
     * obtener información de anulación a actualizar
     */

    /**
     * actualizar información de anulación
     */

    ////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////          OPERACIONES CUENTA     /////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////

    /**
     * registro de usuarios a tráves de FB
     */
    // if (type === "registerFB") {
    //   /*sr = `<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
    //     <soap:Body>
    //       <register_ws xmlns="http://warehouse.example.com/ws">
    //         <api>${this.token}</api>
    //         <email>${object["email"]}</email>
    //         <firstname>${object["firstname"]}</firstname>
    //         <lastname>${object["lastname"]}</lastname>
    //         <password>${object["password"]}</password>
    //         <fbid>${object["fbid"]}</fbid>
    //         <fbpic>${object["fbpic"]}</fbpic>
    //       </register_ws>
    //     </soap:Body>
    //   </soap:Envelope>`;*/
    //   sr = this.buildSoapRequest("register_ws", {
    //     api:this.token,
    //     email:object["email"],
    //     firstname:object["firstname"],
    //     lastname:object["lastname"],
    //     password:object["password"],
    //     fbid:object["fbid"],
    //     fbpic:object["fbpic"]
    //   });
    //   endpoint = `${this.urlBase}/user_register.php`;
    // }

    /**
     * puntos del usuario
     */

    /**
     * boletos del usuario
     */

    /**
     * boletos del usuario para traslados
     */

    /**
     * anulaciones del usuario
     */

    /**
     * TODO este webservice no está siendo utilizado
     */
    // if (type === "cancelled_by_email") {
    //   sr = `<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
    //     <soap:Body>
    //       <get_cancelled_ws xmlns="http://warehouse.example.com/ws">
    //         <api>${this.token}</api>
    //         <email>J.VERA_R@HOTMAIL.COM</email>
    //       </get_cancelled_ws>
    //     </soap:Body>
    //   </soap:Envelope>`;
    //   endpoint = `${this.urlBase}/user_get_cancelled.php`;
    // }

    ////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////          OPERACIONES CUPONES    /////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////

    /**
     * obtener cupones de un usuario
     */

    /**
     * canjear cupones con puntos del usuario
     */

    ////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////          PASAJEROS FRECUENTES   /////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////

    /**
     * obtener pasajero frecuente
     */

    ////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////      WEBSERVICES SIN FUNCIÓN    /////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////

    /**
     * TODO este webservice no está siendo utilizado
     */
    // if (type === "get_countries") {
    //   sr = `<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
    //     <soap:Body>
    //       <get_countries_ws xmlns="http://warehouse.example.com/ws">
    //         <api>${this.token}</api>
    //       </get_countries_ws>
    //     </soap:Body>
    //   </soap:Envelope>`;
    //   endpoint = `${this.urlBase}/get_countries.php`;
    // }

    // if (type === "create_session") {
    //   callPost = false;
    //   endpoint = `${environment.urlApiChilepasajes}/create_session_rest`;
    // }

    ////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////          VIAJES ESPECIALES      /////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////

    // 5449670!189277318!JUAN PABLO!MUñOZ ARIAS!Enrique Mac Iver 38, Santiago, Chile,German Riesco 399, Zapallar, Chile!00:00!RUT
    // 5329179!197858710!KENDAL FRANCO!SEPULVEDA SALAS!CL!Calle San Ignacio de Loyola 633,Santiago, Chile!Aeropuerto SCL, Chile!12-03-2023!RUT

    // if (type === "set_special_ve_ida") {
    //   // sólo ida
    //   sr = `
    //       <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
    //         <soapenv:Body>
    //           <special_trips_ws>
    //             <comprador>
    //             {
    //               "nombre": "${object["usuario"].nombre}",
    //               "apellido": "${object["usuario"].apellido}",
    //               "correo": "${object["usuario"].correo}",
    //               "phone": "${object["usuario"].phone}"
    //             }
    //             </comprador>
    //             <viaje_ida>
    //             {
    //               "tipo_servicio": "${object["viajeIda"].tipo_servicio}",
    //               "tipo_vehiculo": "${object["viajeIda"].tipo_vehiculo}",
    //               "adult": "${object["viajeIda"].adult}",
    //               "children": "${object["viajeIda"].children}",
    //               "baby": "${object["viajeIda"].baby}",
    //               "origen": "${object["viajeIda"].origen}",
    //               "destino": "${object["viajeIda"].destino}",
    //               "stops_1": "${object["viajeIda"].stops_1}",
    //               "stops_2": "${object["viajeIda"].stops_2}",
    //               "stops_3": "${object["viajeIda"].stops_3}",
    //               "fecha": "${object["viajeIda"].fecha}",
    //               "hora": "${object["viajeIda"].hora}"
    //             }
    //             </viaje_ida>
    //             <viaje_reg></viaje_reg>
    //           </special_trips_ws>
    //         </soapenv:Body>
    //       </soapenv:Envelope>`;
    //   endpoint = `${this.urlBase}/special_trips.php`;
    // }

    // if (type === "set_special_ve_ida_vuelta") {
    //   // ida y vuelta
    //   sr = `
    //       <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
    //         <soapenv:Body>
    //           <special_trips_ws>
    //             <comprador>
    //             {
    //               "nombre": "${object["usuario"].nombre}",
    //               "apellido": "${object["usuario"].apellido}",
    //               "correo": "${object["usuario"].correo}",
    //               "phone": "${object["usuario"].phone}"
    //             }
    //             </comprador>
    //             <viaje_ida>
    //             {
    //               "tipo_servicio": "${object["viajeIda"].tipo_servicio}",
    //               "tipo_vehiculo": "${object["viajeIda"].tipo_vehiculo}",
    //               "adult": "${object["viajeIda"].adult}",
    //               "children": "${object["viajeIda"].children}",
    //               "baby": "${object["viajeIda"].baby}",
    //               "origen": "${object["viajeIda"].origen}",
    //               "destino": "${object["viajeIda"].destino}",
    //               "stops_1": "${object["viajeIda"].stops_1}",
    //               "stops_2": "${object["viajeIda"].stops_2}",
    //               "stops_3": "${object["viajeIda"].stops_3}",
    //               "fecha": "${object["viajeIda"].fecha}",
    //               "hora": "${object["viajeIda"].hora}"
    //             }
    //             </viaje_ida>
    //             <viaje_reg>
    //             {
    //               "tipo_servicio": "${object["viajeVuelta"].tipo_servicio}",
    //               "tipo_vehiculo": "${object["viajeVuelta"].tipo_vehiculo}",
    //               "adult": "${object["viajeVuelta"].adult}",
    //               "children": "${object["viajeVuelta"].children}",
    //               "baby": "${object["viajeVuelta"].baby}",
    //               "origen": "${object["viajeVuelta"].origen}",
    //               "destino": "${object["viajeVuelta"].destino}",
    //               "stops_1": "${object["viajeVuelta"].stops_1}",
    //               "stops_2": "${object["viajeVuelta"].stops_2}",
    //               "stops_3": "${object["viajeVuelta"].stops_3}",
    //               "fecha": "${object["viajeVuelta"].fecha}",
    //               "hora": "${object["viajeVuelta"].hora}"
    //             }
    //             </viaje_reg>
    //           </special_trips_ws>
    //         </soapenv:Body>
    //       </soapenv:Envelope>`;
    //   endpoint = `${this.urlBase}/special_trips.php`;
    // }

    ////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////          PRODUCOS POST COMPRA   /////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////

    if (type === 'insurance_not_purchased') {
      /*  sr = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
                <soapenv:Body>
                  <purchase_details_ws>
                    <idpago>${object["idPago"]}</idpago>
                    <sessionid>${object["idSession"]}</sessionid>
                  </purchase_details_ws>
                </soapenv:Body>
              </soapenv:Envelope>`;*/
      sr = this.buildSoapRequest('purchase_details_ws', {
        idpago: object['idpago'],
        sessionid: object['idSession'],
      });
      endpoint = `${this.urlBase}/post_01_purchase_details.php`;
    }

    if (type === 'pay_insurance_not_purchased') {
      if (object['type'] == 1) {
        sr = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
        <soapenv:Body>
          <add_products_ws>
            <idpago>${object['idPago']}</idpago>
            <productos>[
              {
                "serial":"${object['productos'][0].serial}",
                "cantidad":"${object['productos'][0].cantidad}"
              }
            ]</productos>
            <paymentmethod>WEBPAY</paymentmethod>
            <device>P</device>
          </add_products_ws>
        </soapenv:Body>
        </soapenv:Envelope>`;
      } else {
        sr = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
        <soapenv:Body>
          <add_products_ws>
            <idpago>${object['idPago']}</idpago>
            <productos>[
              {
                "serial":"${object['productos'][0].serial}",
                "cantidad":"${object['productos'][0].cantidad}"
              },
              {
                "serial":"${object['productos'][1].serial}",
                "cantidad":"${object['productos'][1].cantidad}"
              }
            ]</productos>
            <paymentmethod>WEBPAY</paymentmethod>
            <device>P</device>
          </add_products_ws>
        </soapenv:Body>
      </soapenv:Envelope>`;
      }

      //https://api.chilepasajes.cl/api/chilepasajes/web/1.0/post_02_add_products.php

      endpoint = `${this.urlBase}/post_02_add_products.php`;
    }

    if (type === 'pay_insurance_response') {
      /*sr = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
              <soapenv:Body>
                <products_exito_ws>
                <idpago_post>${object["codigoData"]}</idpago_post>
                </products_exito_ws>
              </soapenv:Body>
            </soapenv:Envelope>`;*/
      sr = this.buildSoapRequest('products_exito_ws', {
        idpago: object['idpago'],
      });
      //https://api.chilepasajes.cl/api/chilepasajes/web/1.0/post_03_products_exito.php
      endpoint = `${this.urlBase}/post_03_products_exito.php`;
    }

    ////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////          PANORAMAS              /////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////

    // if (type === "pago_panorama") {
    //   sr = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
    //           <soapenv:Body>
    //             <set_pago_panorama>
    //               <array>${object["array"]}</array>
    //             </set_pago_panorama>
    //           </soapenv:Body>
    //         </soapenv:Envelope>`;
    //   endpoint = `http://localhost/api/chilepasajes/panorama/pago_panorama.php`;
    // }

    // if (type === "reserva_panorama") {
    //   sr = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
    //           <soapenv:Body>
    //             <set_pago_reserva_panorama>
    //               <array>${object["array"]}</array>
    //               <idpago>${object["idpago"]}</idpago>
    //               <total>${object["total"]}</total>
    //               <arrayPanorama>${object["panoramas"]}</arrayPanorama>
    //             </set_pago_reserva_panorama>
    //           </soapenv:Body>
    //         </soapenv:Envelope>`;
    //   endpoint = `http://localhost/api/chilepasajes/panorama/reserva_panorama.php`;
    // }

    ////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////

    if (type === 'resend_ticket_mail') {
      callPost = false;
      endpoint = `${this.urlApiGatwayCache}/buses/send_email/?order=${object['order']}&api=${this.token}`;
    }

    /**********************************
                  API CALLS       
    **********************************/
    if (callRestPost) {
      return this.restCallPost(
        endpoint,
        accessToken,
        CacheEnApi,
        formData,
        bodyType
      );
    }
    if (callPost) {
      return this.soapCall(endpoint, sr, soap_act);
    }

    return this.restCallGet(endpoint, accessToken, CacheEnApi);
  }

    


  // hitesApi() {
  //   var data =
  //     "order_amount=" +
  //     2000 +
  //     "&merchant_order_id=" +
  //     1234 +
  //     "&order_description=test&notification_url=http://www.google.cl&return_url=http://www.google.cl";

  //   const xmlhttp = new XMLHttpRequest();
  //   xmlhttp.open("POST", environment.urlClickyPaga, false);
  //   //xmlhttp.setRequestHeader('Content-Type', 'application/json');
  //   xmlhttp.setRequestHeader(
  //     "Content-Type",
  //     "application/x-www-form-urlencoded"
  //   );
  //   xmlhttp.setRequestHeader(
  //     "Authorization",
  //     "Bearer LmOgzsHgxLEU7f6glFMjgqndaJrfEdwtRRso0Rs8"
  //   );

  //   //xmlhttp.responseType = 'document';
  //   //xmlhttp.timeout = 55000; // tiempo en milisegundos

  //   return new Promise((resolve, reject) => {
  //     xmlhttp.onreadystatechange = () => {
  //       if (xmlhttp.readyState == 4) {
  //         if (xmlhttp.status == 200) {
  //           const xml = xmlhttp.response;
  //           resolve(xml);
  //         } else {
  //           reject(`${xmlhttp.status}`);
  //           //----LOG REMOTO --//
  //           let arrLog = [];
  //           arrLog.push("Webservices");
  //           arrLog.push("Hites");
  //           arrLog.push("error:" + xmlhttp.status);

  //           //----------------//
  //         }
  //       }
  //     };
  //     xmlhttp.ontimeout = function (e) {};
  //     xmlhttp.send(data);
  //   });
  // }

  /**
   * Hace un HTTP GET request usando XMLHttpRequest y manejado con Promise
   * @param {string} endpoint La URL a la cual se le hará la request
   * @param {boolean} [key=true] [Opcional] (actualmente no usado en la implementación)
   * @param {boolean} [CacheEnApi] [Opcional] controla como se maneja caché. Si es falso, setea Cache-Control header a max-age = 0
   *
   * @returns {Promise<string>} Promesa que resuelve con la respuesta de la API si es exitoso, si no devuelve error status
   *
   * @throws {string} Retorna una Promesa rechazada con 'Deshabilitado por SSR para el build' si XMLHttpResquest no está disponible
   */
  restCallGet(endpoint, accessToken = null, CacheEnApi) {
    if (typeof XMLHttpRequest !== 'undefined') {
      var xmlhttp = new XMLHttpRequest();
      xmlhttp.open('GET', endpoint);
      xmlhttp.timeout = 29000; // time in milliseconds (29 segundos)
      xmlhttp.setRequestHeader('Content-Type', 'application/json');
      if (CacheEnApi == false) {
        xmlhttp.setRequestHeader('Cache-Control', 'max-age=0');
      }

      if (accessToken) {
        xmlhttp.setRequestHeader('Token', `${accessToken}`);
      }

      xmlhttp.setRequestHeader('Authorization', `Bearer ${this.authToken}`);


      return new Promise((resolve, reject) => {
        xmlhttp.onreadystatechange = () => {
          if (xmlhttp.readyState == 4) {
            if (xmlhttp.status == 200) {
              resolve(xmlhttp.response);
            } else {
              reject(`${xmlhttp.status}`);
              //----LOG REMOTO --//
              let arrLog = [];
              arrLog.push('Webservices');
              arrLog.push(endpoint);
              arrLog.push('error:' + xmlhttp.status);

              //----------------//
            }
          }
        };
        xmlhttp.ontimeout = function (e) {};
        xmlhttp.send();
      });
    } else {
      return Promise.reject('Desabilitado por SSR para el build');
    }
  }

  /**
   * Hace un HTTP POST request que por ahora soporta formatos JSON y URL-encoded del payload
   * @param {string} endpoint La URL a la cual se le hará la request
   * @param {boolean} [CacheEnApi=true] [Opcional] controla como se maneja caché. Si es falso, setea Cache-Control header a max-age = 0
   * @param {object|null} [body=null] el payload que será enviado
   * @param {boolean} [isFormUrlEncoded=false] Determina is la request debe usar formato form URL-encoded
   *
   * @returns {Promise<string>} Promise que entrega la data de la API si es exitosa, si no es rechazada con el código del estado de error
   *
   * @throws {string} Retorna una Promesa rechazada con 'Deshabilitado por SSR para el build' si XMLHttpRequest no está disponible
   */
  restCallPost(
    endpoint: string,
    accessToken = null,
    CacheEnApi = true,
    body = null,
    bodyType = 'urlEncoded'
  ) {
    const headers: { [key: string]: string } = {
      'Authorization': `Bearer ${this.authToken}`
    };

    if (bodyType === 'urlEncoded') {
      headers['Content-Type'] = 'application/x-www-form-urlencoded';
    } else {
      headers['Content-Type'] = 'application/json';
    }

    if (CacheEnApi === false) {
      headers['Cache-Control'] = 'max-age=0';
    }

    if (accessToken) {
      headers['Token'] = `${accessToken}`;
    }

    let requestBody: any;
    if (body) {
      if (bodyType === 'urlEncoded') {
        requestBody = new URLSearchParams();
        Object.keys(body).forEach(key => {
          requestBody.set(key, body[key]);
        });
      } else {
        requestBody = body;
      }
    }

    return new Promise((resolve, reject) => {
      const subscription = this.http.post(endpoint, requestBody, {
        headers,
        responseType: 'text',
        withCredentials: false
      }).subscribe({
        next: (response) => {
          resolve(response);
          subscription.unsubscribe();
        },
        error: (error) => {
          reject(`${error.status}`);
          let arrLog = [];
          arrLog.push('Webservices');
          arrLog.push(endpoint);
          arrLog.push('error:' + error.status);
          subscription.unsubscribe();
        }
      });

      // Set timeout
      setTimeout(() => {
        subscription.unsubscribe();
        reject('Request timeout');
      }, 29000);
    });
  }

  soapCall(endpoint: any, src: any, soap_act: any) {
    const xmlhttp = new XMLHttpRequest();
    xmlhttp.open('POST', endpoint, true);
    xmlhttp.setRequestHeader('Content-Type', 'text/xml');
    xmlhttp.setRequestHeader('SOAPAction', soap_act);
    /*  if (soap_act) {
       
        xmlhttp.setRequestHeader(
          "Ocp-Apim-Subscription-Key",
          "6783cd086d664400a136c05d9c168bf5"
        );
        xmlhttp.setRequestHeader("Ocp-Apim-Trace", "true");
      }*/
    xmlhttp.withCredentials = false;
    xmlhttp.responseType = 'document';
    xmlhttp.timeout = 55000; // tiempo en milisegundos

    return new Promise((resolve, reject) => {
      xmlhttp.onreadystatechange = () => {
        if (xmlhttp.readyState == 4) {
          if (xmlhttp.status == 200) {
            const xml = xmlhttp.responseXML;

            if (xml.getElementsByTagName) {
              const response_number =
                xml.getElementsByTagName('return')[0].childNodes[0];
              resolve(response_number['nodeValue']);
            }
          } else {
            reject(`${xmlhttp.status}`);
            //----LOG REMOTO --//
            let arrLog = [];
            arrLog.push('Webservices');
            arrLog.push(endpoint);
            arrLog.push('error:' + xmlhttp.status);

            //----------------//
          }
        }
      };
      xmlhttp.ontimeout = function (e) {};
      xmlhttp.send(src);
    });
  }
}
